import { Outlet } from 'react-router-dom';
import { AnnouncementBar } from '@/components/AnnouncementBar';
import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import { AssistantWidget } from '@/components/AssistantWidget';
import { ScrollToTop } from './ScrollToTop';

/** 全站骨架：跳转链接、公告条、页头、页面内容、页脚。 */
export function AppShell() {
  return (
    <div className="flex min-h-dvh flex-col bg-surface-0">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:top-3 focus:left-3 focus:z-50 focus:rounded-btn focus:bg-brand focus:px-4 focus:py-2 focus:text-sm focus:text-grad-fg"
      >
        跳到主要内容
      </a>
      <ScrollToTop />
      <AnnouncementBar />
      <Header />
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <AssistantWidget />
    </div>
  );
}
